module.exports = __webpack_public_path__ + "assets/img/logAudit-module6-2.85f26a2c.jpg";